import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import EmptySection from "../../components/EmptySection";
import emptyImage2 from "../../images/redesignImages/345-loader-16 1.svg";
import React from "react";
import { useHistory } from "react-router-dom";
import PayableList from "./PayableList";

const DashboardPayableInvoicesList = ({ agreementClaims }) => {
  const { push: redirect } = useHistory();
  return Boolean(agreementClaims?.total) ? (
    <Paper
      style={{
        height: "calc(100% - 2rem)",
        paddingLeft: "40px",
        paddingRight: "40px"
      }}
    >
      <Box>
        <Grid
          item
          style={{
            paddingBottom: "2rem"
          }}
        >
          <Typography variant={"h4"}>Fizetendő számlák</Typography>
        </Grid>
        <PayableList hideSearchBar hidePager />
      </Box>
    </Paper>
  ) : (
    <EmptySection
      sectionTitle={"Fizetendő számlák"}
      imgSrc={emptyImage2}
      onClick={() => redirect("/app/invoice")}
    />
  );
};

export default DashboardPayableInvoicesList;
